import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { convertStringToElements } from "@vds/html-parsers";
import moment from "moment";

import { setA11yContent } from "../../NavigationHelper/actions";
import { checkNestedObject } from "utils/checkNestedObject";
import { cleanDateFormat } from "utils/cleanDateFormat";
import { renderDate } from "utils/renderDate";
import { handleModalState } from "common-components/Modal/actions/handleModalState";
import { renewOrRemoveAuthAgent } from "./actions";

import Header from "common-components/Header";
import Container from "common-components/Container";
import RectangleLoader from "common-components/RectangleLoader";
import Alert from "common-components/Alert";
import StyledLink from "common-components/StyledLink";
import Button from "common-components/Buttons";
import { AgentInfoTable } from "./AgentInfoTable";
import { ManageAgentModal } from "./ManageAgentModal";
import { AuthorizedAgentExpired } from "./AuthorizedAgentExpired";

class ManageAuthorizedAgent extends Component {
  state = {
    modalToDisplay: ""
  };

  componentDidMount() {
    if (checkNestedObject(this.props, "pageContent", "sc_pagetitle")) {
      this.props.setA11yContent("manage authorized agent", this.props.pageContent.sc_pagetitle);
    }
  }

  renderAgentTable = ([{ text: header, list: headerList }]) => {
    const {
      agentDetails: [agentDetails]
    } = this.props;

    return (
      <AgentInfoTable
        agentEmail={agentDetails.agentEmailId}
        agentName={agentDetails.entityName}
        assignedDate={moment(cleanDateFormat(agentDetails.effectiveDate)).format("MMM D, YYYY")}
        phoneNumber={agentDetails.agentRegId}
        expirationDate={renderDate(agentDetails.endDate)}
        renewButtonClick={() => this.handleRemoveAndRenewClick("renewAgent")}
        header={header}
        headerList={headerList}
        showRenewButton={agentDetails.renew === "Y"}
      />
    );
  };

  handleRemoveAndRenewClick = modalToDisplay => {
    this.setState({ modalToDisplay }, () => {
      this.props.handleModalState();
    });
  };

  handleApiCall = type => {
    this.props.handleModalState(false);
    this.props.renewOrRemoveAuthAgent(type).then(() => {
      if (!this.props.error) {
        this.props.history.push("/privacy/secure/your-data/authorized-agent/success", { type });
      }
    });
  };

  renderModal = () => {
    const { modalToDisplay } = this.state;
    const { renew_agent_modal, remove_agent_modal } = this.props;

    if (modalToDisplay) {
      if (modalToDisplay === "removeAgent") {
        return (
          <ManageAgentModal
            contentLabel="remove agent"
            handleCancel={() => this.props.handleModalState(false)}
            handleClick={() => this.handleApiCall("Cancel")}
            modalContent={remove_agent_modal}
          />
        );
      } else {
        return (
          <ManageAgentModal
            contentLabel="renew agent"
            handleCancel={() => this.props.handleModalState(false)}
            handleClick={() => this.handleApiCall("Renew")}
            modalContent={renew_agent_modal}
          />
        );
      }
    }
    return null;
  };

  render() {
    if (!checkNestedObject(this.props, "manageAgentPageContent", "section_title")) {
      return <Redirect to="/privacy/secure/your-data" />;
    }

    if (this.props.loading) {
      return <RectangleLoader />;
    }

    const {
      section_title: manageTitle,
      genericList: manageTableContent,
      buttons: manageButtons
    } = this.props.manageAgentPageContent;
    const {
      expiredAgentPageContent,
      agentDetails: [agentDetails]
    } = this.props;

    return (
      <Container>
        {this.props.error ? <Alert alertType="error">{this.props.error}</Alert> : null}
        {this.renderModal()}
        <div style={{ maxWidth: "596px" }}>
          {agentDetails.status.toUpperCase() === "EXPIRED" ? (
            <AuthorizedAgentExpired
              pageContent={expiredAgentPageContent}
              renderAgentTable={() => this.renderAgentTable(expiredAgentPageContent.genericList)}
              assignNewAgentClick={() => this.props.history.push("assign")}
            />
          ) : (
            <Fragment>
              <Header style={{ marginBottom: "40px" }}>{convertStringToElements(manageTitle)}</Header>
              {this.renderAgentTable(manageTableContent)}
              <div>
                <StyledLink to="/privacy/secure/your-data" background={manageButtons[0].type}>
                  {manageButtons[0].text}
                </StyledLink>
                <Button
                  onClick={() => this.handleRemoveAndRenewClick("removeAgent")}
                  background={manageButtons[1].type}
                >
                  {manageButtons[1].text}
                </Button>
              </div>
            </Fragment>
          )}
        </div>
      </Container>
    );
  }
}

const mapStateToProps = ({
  pageContent: {
    manage_agent: manageAgentPageContent,
    expired_agent: expiredAgentPageContent,
    renew_agent_modal,
    remove_agent_modal
  },
  downloadAndDelete: { agentDetailsData: agentDetails },
  modalState: { showModal },
  loadingAndErrorState: { loading, error }
}) => ({
  manageAgentPageContent,
  expiredAgentPageContent,
  agentDetails,
  showModal,
  remove_agent_modal,
  renew_agent_modal,
  loading,
  error
});

export default connect(
  mapStateToProps,
  { setA11yContent, handleModalState, renewOrRemoveAuthAgent }
)(ManageAuthorizedAgent);
